export default __webpack_public_path__ + "static/media/gyroZ.e447acb0.svg";